import Loader from '@/components/Loader';
import { useGroupId } from '@/hooks/useGroup';
import { ApplicationState } from '@/store';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { SelectCondition } from './SelectCondition/SelectCondition';
import './style.scss';

const FormGroup: React.FC = () => {
    const [groupName, setGroupName] = useState<string>('');
    const { strings } = useSelector((state: ApplicationState) => ({
        strings: state.locale.data,
    }));

    const history = useHistory();

    const { id } = useParams<{ id: string }>();
    const groupId: number = Number(id);

    const { group, isLoading, revalidateResult } = useGroupId(groupId);

    useEffect(() => {
        if (group?.name) {
            setGroupName(group.name);
        }
    }, [group?.name]);

    const goBackToPeople = (): void => history.push('/people');

    useEffect(() => {
        return () => {
            revalidateResult();
        };
    }, []);

    return (
        <>
            {id && isLoading && <Loader />}
            {!isLoading && (
                <>
                    <div className="form-group-enrollment__back-button go-back navbar navbar-expand sub-nav">
                        <span className="container" onClick={goBackToPeople}>
                            <i className="material-icons-outlined align-middle">keyboard_arrow_left</i>
                            <span>{strings.GO_BACK}</span>
                        </span>
                    </div>
                    <div className="form-group-enrollment">
                        <span className="edit-public">{id ? strings.GROUP_EDIT : strings.GROUP_REGISTRATION}</span>
                        <span className="title">{strings.TARGET_NAME}</span>
                        <input
                            className="form-control input"
                            onChange={(e) => setGroupName(e.target.value)}
                            placeholder={strings.NAME_PUBLIC}
                            type="text"
                            value={groupName}
                        />
                        <SelectCondition groupId={group?.id} groupName={groupName} groupRule={group?.rules} />
                    </div>
                </>
            )}
        </>
    );
};

export default FormGroup;
